<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="/sites" class="m-1 mr-2" tourAnchor="tour.navigate.sites">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>

    <button mat-raised-button *ngIf="site.parent_site_id" [routerLink]="'/sites/'+site.parent_site_id+'/children'" class="m-1 mr-2" tourAnchor="tour.navigate.sites">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
    </button>

    <button mat-raised-button [routerLink]="utils.prepareSiteRelatedLink(site.id, site.parent_site_id, 'view/induction')" *ngIf="site.id" class="m-1 mr-2">
      <mat-icon>visibility</mat-icon> View
    </button>
  </span>

  <!--button mat-icon-button (click)="onStartTour()" appMarginRight><mat-icon>help</mat-icon></button-->
</nav>

<div class="container-fluid p-0">

  <div class="card rounded-0">
    <div class="card-body">

      <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">

        <editor
          *ngIf="contentLoaded"
          placeholder="Noticeboard Content"
          [(ngModel)]="site.induction_content"
          name="induction_content"
          id="induction_content"
          [apiKey]="utils.getTinyMceAPIKey()"
          [init]="{
            base_url: '/assets/tinymce',
            plugins: 'link image lists table media charmap',
            menu: {
              format: {
                title: 'Format',
                items: 'bold italic underline strikethrough superscript subscript codeformat | blocks align | forecolor backcolor | removeformat'
              }
            },
            toolbar: 'undo redo | bold italic underline | forecolor backcolor | bullist numlist | link image media | table | hr | removeformat',
            license_key: 'gpl',
            height: 600
          }">
        </editor>

        <div class="row mt-2">
          <div class="col">
            <button
              mat-raised-button
              [disabled]="!f.valid || inProgress"
              (click)="onSubmit(f)"
              color="primary"
              class="my-2 ml-0 mr-2"
              type="button">
              <mat-icon>save</mat-icon> Save
            </button>
          </div>
        </div>

      </form>

    </div>
  </div>

</div>
